import cn from 'classnames';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import logo_big from '../../../../assets/media/Logo/logo_big_white.png';
import logo_small from '../../../../assets/media/Logo/logo_small_white.png';
import { NAVIGATION } from '../../../../routers/routes';
import SidebarBlueTab from './SidebarBlueTab';
import styles from './styles.module.scss';


const sidebarExpanded = false


const Logo = ({ sidebarExpanded }) => (
  <img alt="logo" src={sidebarExpanded ? logo_big : logo_small} className={styles.sidebar_logo} />
);

const SidebarBlue = ({ open_tab }) => {
  let [isTest, useIsTest] = useState(false);
  const location = useLocation()
  const { accesses, role } = useSelector((state) => state.user);


  useEffect(() => {
    useIsTest(process.env.REACT_APP_IS_TEST === 'true');
  }, [process.env.IS_TEST]);


  return (
    <div
      className={cn(
        styles.sidebar,
        sidebarExpanded ? styles.sidebar_open : styles.sidebar_close,
        isTest && styles.sidebar_test,
      )}
    >
      <div className={styles.line_logo}>
        <Logo {...{ sidebarExpanded }} />
      </div>

      {/* console.log() */}
      {Object.values(NAVIGATION).filter(nav => !nav.isNotSideBarPage)
        .filter(nav => Object.values(accesses[nav.rootUrl]).some(acs => acs) || role === 'owner')
        .map(nav => {
          return (
            <SidebarBlueTab
              img={nav.imgSideBar}
              sidebarExpanded={false}
              isActive={location.pathname.startsWith(`/${nav.rootUrl}/`)}
              key={nav.rootUrl}
              link={`/${nav.rootUrl}/`}
              text={nav.text}
              show={true}
              isTest={isTest}
            />
          )
        })}
    </div>
  );
};


export default SidebarBlue;
